<template>
   <div>
      <!-- PARTIE RUCHE  -->
      <div class="container-mobile sous-titre">Informations générales</div>
      <div class="spinner-container" v-if="loading">
         <BeatLoader color="#1389EF" />
      </div>
      <div v-else>
         <div class="flex" style="justify-content:space-between">
            <div class="my-card-row">
               <div class="my-card-container">
                  <div class="my-card">
                     <div class="my-card-header">Type</div>
                     <div class="my-card-content">{{ ruche.type }}</div>
                  </div>
               </div>
               <div class="my-card-container">
                  <div class="my-card">
                     <div class="my-card-header">Lignée</div>
                     <div class="my-card-content">{{ ruche.lignee ? ruche.lignee : 'N/C' }}</div>
                  </div>
               </div>
               <div class="my-card-container">
                  <div class="my-card">
                     <div class="my-card-header">
                        Année
                        <b-icon icon="gender-female" size="is-small" />
                     </div>
                     <div
                        class="my-card-content"
                     >{{ ruche.annee_naissance_reine ? ruche.annee_naissance_reine : 'N/C' }}</div>
                  </div>
               </div>
               <div class="my-card-container">
                  <div class="my-card">
                     <div class="my-card-header">Poids</div>
                     <div
                        class="my-card-content"
                     >{{ derniere_visite.poids ? derniere_visite.poids + ' KG' : 'N/C' }}</div>
                  </div>
               </div>
               <div class="my-card-container">
                  <div class="my-card">
                     <div class="my-card-header">Comportement</div>
                     <div
                        class="my-card-content"
                     >{{ derniere_visite.comportement ? derniere_visite.comportement : "N/C" }}</div>
                  </div>
               </div>
               <div class="my-card-container">
                  <div class="my-card">
                     <div class="my-card-header">Réserves miel</div>
                     <div
                        class="my-card-content"
                     >{{ derniere_visite.reserves_miel ? derniere_visite.reserves_miel + ' KG' : 'N/C' }}</div>
                  </div>
               </div>
            </div>
         </div>
      </div>

      <!-- graphique récoltes  -->
      <div class="container-mobile sous-titre">Récoltes</div>
      <bar-chart
         :height="300"
         ref="nourrissementRucher"
         :chart-data="graphRecoltes.chartData"
         :options="graphRecoltes.options"
      ></bar-chart>

      <!-- PARTIE Nourrissement  -->
      <div class="container-mobile sous-titre" style="margin-top:30px;">Nourrissement</div>
      <div class="spinner-container" v-if="loading">
         <BeatLoader color="#1389EF" />
      </div>
      <div v-else>
         <div class="my-card-row">
            <div class="my-card-container">
               <div class="my-card">
                  <div class="my-card-header">Total sirop 2019</div>
                  <div class="my-card-content">{{ nourrissement.sirop }} L</div>
               </div>
            </div>
            <div class="my-card-container">
               <div class="my-card">
                  <div class="my-card-header">Total candi 2019</div>
                  <div class="my-card-content">{{ nourrissement.candi }} KG</div>
               </div>
            </div>
         </div>
      </div>

      <!-- PArtie actions  -->
      <div class="container-mobile sous-titre">Actions à prévoir</div>
      <div class="my-card-row">
         <div class="my-card-container">
            <div class="my-card">
               <div
                  class="my-card-header"
                  :class="derniere_visite.nourrissement_a_prevoir ? 'bg-danger' : 'bg-success'"
               >Nourrissement</div>
               <div class="my-card-content">
                  <div v-if="loading">
                     <BeatLoader />
                  </div>
                  <div v-else>{{ derniere_visite.nourrissement_a_prevoir ? 'Oui' : 'Non' }}</div>
               </div>
            </div>
         </div>
         <div class="my-card-container">
            <div class="my-card">
               <div
                  class="my-card-header"
                  :class="derniere_visite.traitement_a_prevoir ? 'bg-danger' : 'bg-success'"
               >Traitement</div>
               <div class="my-card-content">
                  <div v-if="loading">
                     <BeatLoader />
                  </div>
                  <div v-else>{{ derniere_visite.traitement_a_prevoir ? 'Oui' : 'Non' }}</div>
               </div>
            </div>
         </div>
         <div class="my-card-container">
            <div class="my-card">
               <div
                  class="my-card-header"
                  :class="derniere_visite.hausses_a_poser ? 'bg-danger' : 'bg-success'"
               >Hausses à poser</div>
               <div class="my-card-content">
                  <div v-if="loading">
                     <BeatLoader />
                  </div>
                  <div v-else>{{ derniere_visite.hausses_a_poser ? 'Oui' : 'Non' }}</div>
               </div>
            </div>
         </div>
         <div class="my-card-container">
            <div class="my-card">
               <div
                  class="my-card-header"
                  :class="derniere_visite.reine_a_changer ? 'bg-danger' : 'bg-success'"
               >Reine à changer</div>
               <div class="my-card-content">
                  <div v-if="loading">
                     <BeatLoader />
                  </div>
                  <div v-else>{{ derniere_visite.reine_a_changer ? 'Oui' : 'Non' }}</div>
               </div>
            </div>
         </div>
         <div class="my-card-container">
            <div class="my-card">
               <div
                  class="my-card-header"
                  :class="derniere_visite.nettoyage_planchers_fait ? 'bg-success' : 'bg-danger'"
               >Nettoyage planchers {{ annee }}</div>
               <div class="my-card-content">
                  <div v-if="loading">
                     <BeatLoader />
                  </div>
                  <div v-else>{{ derniere_visite.nettoyage_planchers_fait ? 'Fait' : 'A faire' }}</div>
               </div>
            </div>
         </div>
         <div class="my-card-container">
            <div class="my-card">
               <div
                  class="my-card-header"
                  :class="derniere_visite.renouvellement_cadres ? 'bg-success' : 'bg-danger'"
               >Renouvellement cadres {{ annee }}</div>
               <div class="my-card-content">
                  <div v-if="loading">
                     <BeatLoader />
                  </div>
                  <div v-else>{{ derniere_visite.renouvellement_cadres ? 'Fait' : 'A faire' }}</div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
import axios from "axios";
import { BeatLoader } from "@saeris/vue-spinners";
import BarChart from "@/views/charts/BarChart";

export default {
   name: "BlocInfos",
   components: {
      BeatLoader,
      BarChart
   },
   data() {
      return {
         loading: true,
         nourrissement: {},
         ruche: {},
         derniere_visite: {},
         annee: new Date().getFullYear(),
         graphRecoltes: {
            chartData: {
               labels: [],
               datasets: []
            },
            options: {
               responsive: true,
               maintainAspectRatio: false,
               legend: {
                  display: false
               },
               scales: {
                  xAxes: [
                     {
                        gridLines: {
                           color: "rgba(0, 0, 0, 0.05)"
                        }
                     }
                  ],
                  yAxes: [
                     {
                        ticks: {
                           suggestedMin: 0,
                           suggestedMax: 5
                        },
                        gridLines: {
                           color: "rgba(0, 0, 0, 0.05)"
                        }
                     }
                  ]
               }
            }
         }
      };
   },
   mounted() {
      this.getRuche();
   },
   methods: {
      async getRuche() {
         this.loading = true;
         let res = await axios.get(
            "/ruches/" + this.$route.params.id + "/fiche"
         );
         if (res.data.erreur) {
            this.$buefy.toast.open({
               message: res.data.erreur,
               type: "is-danger"
            });
            this.$router.push({ name: "ruches" });
         }
         this.ruche = res.data.ruche;
         this.nourrissement = res.data.nourrissement;
         if (res.data.derniere_visite) {
            this.derniere_visite = res.data.derniere_visite;
         }
         this.$store.commit("setTitre", res.data.ruche.nom);
         this.loading = false;

         //init le graph
         let noms = [];
         let quantites = [];
         res.data.recoltes.forEach(recolte => {
            noms.push(recolte.nom);
            quantites.push(recolte.quantite);
         });
         this.initGraphRecoltes(quantites, noms);
      },
      initGraphRecoltes(quantites, noms) {
         let chartData = {
            datasets: [
               {
                  label: "Récolte (KG)",
                  data: quantites, // array
                  backgroundColor: [
                     "rgba(165, 0, 255, 1)",
                     "rgba(255, 159, 64, 1)",
                     "rgba(165, 244, 255, 1)",
                     "rgba(125, 0, 245, 1)",
                     "rgba(225, 109, 64, 1)",
                     "rgba(135, 254, 205, 1)"
                  ]
               }
            ],
            labels: noms // array
         };

         this.graphRecoltes.chartData = chartData;
      }
   }
};
</script>
